import { Component } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService, Credentials, UserService, CourseService } from "@bt/core";
import { TokenError } from "./change-password.interfaces";
import { PasswordConfirmModel } from "@bt/core/models/passwordConfirm.model";
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from "@bt/core/base";
import { environment } from "@src/environments/environment";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"]
})
export class ChangePasswordComponent extends BaseComponent {
  public min6symbol:boolean = false;
  public error: TokenError;
  public showLoader: boolean = false;
  public sessionId: string = "";
  public code: string = "";
  public textError: string;
  public userId: string = "";
  private notifier: NotifierService;
  protected logoHeader: string = environment.logoHeader || "Custody project";

  constructor(private userService: UserService, private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    notifierService: NotifierService,
    private courseService: CourseService) {
    super();
      this.notifier = notifierService;
      this.userService.clearAuth();
  }

  public change(passwordConfirmModel: PasswordConfirmModel) {

    var t = this;
    t.setLoading(true);

    this.route.queryParams.subscribe(params => {
        passwordConfirmModel.sessionId = params['sessionId'];
        passwordConfirmModel.code = params['code'];
        t.userId = params['userId'];
        t.setLoading(false);
    });
    this.userService.setPassword(passwordConfirmModel)
      .subscribe((resp) => {
        this.notifier.notify('success', 'Пароль успешно изменен');
        t.setLoading(false);

        const credentials: Credentials = {
          // здесь в качестве email выступает userId, с его помощью также можно авторизоваться
          email: t.userId,
          password: passwordConfirmModel.newPassword
        }
        this.authService
          .login(credentials)
          .subscribe(
            (response) => {
              this.courseService
                .getUser()
                .then(
                  (response) => {

                    if (response.data.role == 1 || response.data.role == 0) {
                      this.router.navigateByUrl("welcome")
                        .then(() => this.showLoader = false);
                    }
                    else if (response.data.role == 2) {
                      this.router.navigateByUrl("all-users")
                        .then(() => this.showLoader = false);
                    }
                  },
                )
                .catch((error) => {
                  console.error(error.error);
                  t.setLoading(false);
                  this.notifier.notify('error', 'Пожалуйста выполните авторизацию');

                    this.authService.logout();
                });

            },
            (error: HttpErrorResponse) => {
              t.error = error.error;
              if (t.error != undefined && t.error.error_description != undefined) {

                t.textError = t.error.error_description;
                if (t.textError == "Invalid username or password")
                  t.textError = "Неправильный логин или пароль";
                var alert = document.getElementsByClassName("myalert");
                (<any>alert[0]).style.display = "block";
                setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
              }

              console.log("Error:" + t.error.error_description);
              this.showLoader = false;
            }
          );

        }, (error) => {
          if(error.error.errorMsgs.includes("Code has been already used")){
          this.notifier.notify('error', 'Эта ссылка уже была активирована');
          t.setLoading(false);
          }
      })
  }

  public clearError() {
    this.error = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/public/change-password/change-password.component.ts